import * as React from 'react'
import { useContext } from 'react'
import Select from 'react-select'
import CommonContext from '../CommonContext'
import { SavedFiltersControllerType } from '../../hooks/useSavedFiltersController'
import SavedFilters from '../job_plannings/filter/SavedFilters'

export type ProductionPlanningFilterShape = {
  areas: string[]
  production_places: string[]
  status_code: string
  hide_items?: boolean
  collapse_job_ids?: boolean
  start_date?: string
  end_date?: string
  // Legacy fields for backward compatibility with saved filters
  area?: string
  production_place?: string
}

type FilterFormProps = {
  savedFiltersController: SavedFiltersControllerType
  closeModal: () => void
}

export default function FilterForm(props: FilterFormProps) {
  const { savedFiltersController, closeModal } = props

  const { availableAreas } = useContext(CommonContext)

  const { setFilter, formFilter, setFormFilter, currentSavedFilter } = savedFiltersController

  const startDate = formFilter.start_date || ''
  const endDate = formFilter.end_date || ''
  // Handle legacy single-value filters for backward compatibility
  const areas = formFilter.areas || (formFilter.area ? [formFilter.area] : [])
  const productionPlaces = formFilter.production_places || (formFilter.production_place ? [formFilter.production_place] : ['east'])
  const statusCode = formFilter.status_code || 'ALL'
  const hideItems = formFilter.hide_items || false
  const collapseJobIds = formFilter.collapse_job_ids || false

  const areaOptions = availableAreas.map(a => ({ label: a, value: a }))
  const productionPlaceOptions = [
    { label: 'Øst', value: 'east' },
    { label: 'Vest', value: 'west' }
  ]

  return (
    <>
      <div className="production-planning-filter-modal-content popup-content">
        <div className="row">
          <div className="form-group col">
            <label htmlFor="production-planning-filter-area">Area</label>
            <Select
              inputId="production-planning-filter-area"
              isMulti
              placeholder="Vælg..."
              options={areaOptions}
              value={areas.map(a => areaOptions.find(o => o.value === a)).filter(Boolean)}
              onChange={opts => setFormFilter({...formFilter, areas: opts ? opts.map(o => o.value) : []})}
            />
          </div>
        </div>
        <div className="row">
          <div className="form-group col">
            <label htmlFor="production-planning-filter-production-place">Producent sted</label>
            <Select
              inputId="production-planning-filter-production-place"
              isMulti
              placeholder="Vælg..."
              options={productionPlaceOptions}
              value={productionPlaces.map(p => productionPlaceOptions.find(o => o.value === p)).filter(Boolean)}
              onChange={opts => setFormFilter({...formFilter, production_places: opts ? opts.map(o => o.value) : []})}
            />
          </div>
        </div>
        <div className="row">
          <div className="form-group col">
            <label htmlFor="production-planning-filter-status-code">Statuscode</label>
            <select
              id="production-planning-filter-status-code"
              className="form-control"
              value={statusCode}
              onChange={e => setFormFilter({...formFilter, status_code: e.target.value})}
            >
              <option value="ALL">ALL</option>
              <option value="PROD-ORDRE">PROD-ORDRE</option>
              <option value="PRODBAKKEN">PRODBAKKEN</option>
            </select>
          </div>
        </div>
        <div className="row">
          <div className="form-group col">
            <label htmlFor="production-plannings-filter-start-date">Dato fra</label>
            <input
              id="production-plannings-filter-start-date"
              type="date"
              className="form-control"
              value={startDate}
              onChange={e => setFormFilter({...formFilter, start_date: e.target.value})}
            />
          </div>
          <div className="form-group col">
            <label htmlFor="production-plannings-filter-end-date">Dato til</label>
            <input
              id="production-plannings-filter-end-date"
              type="date"
              className="form-control"
              value={endDate}
              onChange={e => setFormFilter({...formFilter, end_date: e.target.value})}
            />
          </div>
        </div>
        <div className="row">
          <div className="form-group col">
            <label htmlFor="production-plannings-filter-hide-items">
              <input
                id="production-plannings-filter-hide-items"
                type="checkbox"
                checked={hideItems}
                onChange={e => setFormFilter({...formFilter, hide_items: e.target.checked})}
              />
              <span className='ml-2'>Skjul Varer</span>
            </label>
          </div>
        </div>
        <div className="row">
          <div className="form-group col">
            <label htmlFor="production-plannings-filter-collapse-job-ids">
              <input
                id="production-plannings-filter-collapse-job-ids"
                type="checkbox"
                checked={collapseJobIds}
                onChange={e => setFormFilter({...formFilter, collapse_job_ids: e.target.checked})}
              />
              <span className='ml-2'>Skjul ID'er</span>
            </label>
          </div>
        </div>
        <div className="row">
          <div className="form-group col">
            <hr/>
            <SavedFilters savedFiltersController={savedFiltersController} closeModal={closeModal}/>
          </div>
        </div>
      </div>
      <div className="production-planning-filter-modal-actions popup-actions">
        <button type="button" className="btn btn-outline-secondary" onClick={closeModal}>
          Luk
        </button>
        <button
          type="submit"
          className="btn btn-primary"
          onClick={e => {
            setFilter(formFilter)
            closeModal()
          }}
        >
          Apply filter
        </button>
      </div>
    </>
  )
}
